<template>
  <!--begin::Modal - Create account-->
  <div
    class="modal fade"
    id="kt_register_account_modal_bibo"
    tabindex="-1"
    aria-hidden="true"
    :data-bs-backdrop="false" :data-bs-keyboard="false"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog mw-1000px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Title-->
          <h2>Register BIBO Endorser account</h2>
          <!--end::Title-->

          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body scroll-y m-5">
          <!--begin::Stepper-->
          <div
            ref="createAccountRef"
            class="stepper stepper-links d-flex flex-column"
            id="kt_create_account_stepper"
          >
            <!--begin::Nav-->
            <div class="stepper-nav py-5">
              <!--begin::Step 1-->
              <div class="stepper-item current" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                 Account Info
                </h3>
              </div>
              <!--end::Step 1-->
 

              <!--begin::Step 2-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Activation Info
                </h3>
              </div>
              <!--end::Step 2-->

              <!--begin::Step 2-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Confirmation
                </h3>
              </div>
              <!--end::Step 2-->


              <!--begin::Step 5-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Completed
                </h3>
              </div>
              <!--end::Step 5-->
            </div>
            <!--end::Nav-->

            <!--begin::Form-->
            <form
              class="mx-auto mw-600px w-100 py-10"
              novalidate="novalidate"
              id="kt_create_account_form"
              @submit="handleStep"
            >


              <!--begin::Step 1-->
              <div class="current" data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title--> 
                    <!--end::Title-->

                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                      Please fill-up all the information correctly. 
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <div class="row mb-10">
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">First Name</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title="Your First Name"
                          ></i>
                        </label>
                        <!--end::Label-->

                        

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_firstName"
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_firstName" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->

  
                      </div>
                      <!--end::Input group-->
                    </div> 

                    <div class="col-md-6 fv-row"> 
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label
                            class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                          >
                            <span  >Middle Name</span>
                             
                          </label>
                          <!--end::Label-->

                          <Field
                            type="text"
                            class="form-control form-control-solid"
                            placeholder=""
                            name="insured_middleName"
                            maxlength="50"
                          />
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="insured_middleName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Last Name</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_lastName"
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_lastName" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Birth Date</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="date"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_birthday"
                              format="DD/MM/yyyy"
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_birthday" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  


                  </div>

                  <!--begin::Input group-->
                  <div class="row mb-10">
                    <!--begin::Col-->
                    <div class="col-md-12 fv-row">
                      <!--begin::Label-->
                      <label class="required fs-6 fw-bold form-label mb-2"
                        >Account Access</label
                      >
                      <!--end::Label-->

                      <!--begin::Row-->
                      <div class="row fv-row">
                        <!--begin::Col-->
                        <div class="col-12">
                          <Field
                            name="username"
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Username"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="username" />
                            </div>
                          </div> 
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="password"
                            class="form-control form-control-solid"
                            type="password"
                            placeholder="Password"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="password" />
                            </div>
                          </div>
                          <div class="fs-7 fw-bold text-gray-400">
                            Password
                          </div>
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="cpassword"
                            class="form-control form-control-solid"
                            type="password"
                            placeholder="Confirm Password"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="cpassword" />
                            </div>
                          </div>
                          <div class="fs-7 fw-bold text-gray-400">
                            Confirm Password
                          </div>
                        </div>
                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                    <!--end::Col-->
 
                  </div>
                  <!--end::Input group-->

                  <!--begin::Input group-->
                  <div class="row mb-10" v-if="false">
                    <!--begin::Col-->
                    <div class="col-md-12 fv-row">
                      <!--begin::Label-->
                      <label class="required fs-6 fw-bold form-label mb-2"
                        >Sponsor Info</label
                      >
                      <!--end::Label-->

                      <!--begin::Row-->
                      <div class="row fv-row">
                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="sponsorid"
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Sponsor ID" 
                            :readonly="isDisabledUPID && isBibo"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="sponsorid" />
                            </div>
                          </div> 
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="uplineid"
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Upline ID"
                            :readonly="isDisabledUPID"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="uplineid" />
                            </div>
                          </div> 
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          
                          <Field
                            name="position"
                            class="form-select form-select-lg form-select-solid"
                            as="select"  
                            :disabled="isDisabledUPID"
                          >
                            <option >Select Position</option>
                            <option label="Left" value="L">Left</option>
                            <option label="Right" value="R">Right</option>
                          </Field>

                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="position" />
                            </div>
                          </div> 
                          <div class="fs-7 fw-bold text-gray-400">
                            Position
                          </div>
                        </div>
                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                    <!--end::Col-->
 
                  </div>
                  <!--end::Input group-->
                  
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 1-->



              <!--begin::Step 1-->
              <div   data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title-->
                    <h2 class="fw-bolder d-flex align-items-center text-dark">
                      Enter Activation code
                      <i
                        class="fas fa-exclamation-circle ms-2 fs-7"
                        data-bs-toggle="tooltip" 
                      ></i>
                    </h2>
                    <!--end::Title-->
     
                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                      Activation code can be found in the scratch card inside your package 
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
 
 
                  <div class="row mb-10">
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">User ID</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title=""
                          ></i>
                        </label>
                        <!--end::Label-->

                        <Field
                          type="text"
                          class="form-control form-control-solid"
                          placeholder=""
                          name="userid"
                          maxlength="20" 
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="userid" />
                          </div>
                        </div>
                      </div>
                      <!--end::Input group-->
                    </div> 
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">PIN</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title=""
                          ></i>
                        </label>
                        <!--end::Label-->

                        <Field
                          type="text"
                          class="form-control form-control-solid"
                          placeholder=""
                          name="securitypin"
                          maxlength="20" 
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="securitypin" />
                          </div>
                        </div>
                      </div>
                      <!--end::Input group-->
                    </div> 

                    
                   </div> 
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 1-->
 




              <!--begin::Step 5-->
              <div data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  

                  <!--begin::Body-->
                  <div class="mb-0">
                    

                    <!--begin::Alert-->
                    <div
                      class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
                      v-if="formData.verifyingdata"
                    >
                      <!--begin::Icon-->
                      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
                        <inline-svg
                          src="media/icons/duotone/Code/Warning-1-circle.svg"
                        />
                      </span>
                      <!--end::Icon-->
                      <!--begin::Wrapper-->
                      <div class="d-flex flex-stack flex-grow-1">
                        <!--begin::Content-->
                        <div class="fw-bold" >
                          <h4 class="text-gray-800 fw-bolder">
                            Please wait... verifying data...
                          </h4>
                          <div class="fs-6 text-gray-600">
                            <a href="javascript:;" class="fw-bolder"></a>
                          </div>
                        </div>
                        <!--end::Content-->
                      </div>
                      <!--end::Wrapper-->
                    </div>
                    <!--end::Alert-->

                    <!-- <ConfirmRegisterEC :formdata="formData" v-if="formData.verifyingdata === false"></ConfirmRegisterEC> -->

                    <ConfirmRegisterBiboEndorser :formdata="formData" :userFname="user.fname" v-if="formData.verifyingdata === false"></ConfirmRegisterBiboEndorser>



                  </div>
                  <!--end::Body-->
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 5-->





                <!--begin::Step 5-->
                <div data-kt-stepper-element="content">
                  <div class="w-100 text-center">
                    <!--begin::Heading-->
                    <h1 class="fw-bolder text-dark mb-3"></h1>
                    <!--end::Heading-->

                    <!--begin::Description-->
                    <div class="text-muted fw-bold fs-3">
                      Submitting your application. Please wait
                    </div>
                    <!--end::Description-->

                    <!--begin::Illustration-->
                    <div class="text-center px-4 py-15">
                      <img
                        src="media/illustrations/todo.png"
                        alt=""
                        class="mw-100 mh-150px"
                      />
                    </div>
                    <!--end::Illustration-->
                  </div>
                </div>
                <!--end::Step 5-->


              <!--begin::Actions-->
              <div class="d-flex flex-stack pt-15">
                <!--begin::Wrapper-->
                <div class="me-2">
                  <button
                    type="button"
                    class="btn btn-lg btn-light-primary me-3"
                    data-kt-stepper-action="previous"
                    @click="previousStep()"
                  >
                    <span class="svg-icon svg-icon-3 me-1">
                      <inline-svg
                        src="media/icons/duotone/Navigation/Left-2.svg"
                      />
                    </span>
                    Back
                  </button>
                </div>
                <!--end::Wrapper-->

                <!--begin::Wrapper-->
                <div v-if="formData.verifyingdata === false && currentStepIndex !== (totalSteps -1)">
                  <button
                    type="submit"
                    class="btn btn-lg btn-primary"
                    v-if="currentStepIndex === totalSteps - 2"
                    @click="formSubmit()"
                  >
                    <span class="indicator-label">
                      Submit
                      <span class="svg-icon svg-icon-3 ms-2 me-0">
                        <inline-svg
                          src="icons/duotone/Navigation/Right-2.svg"
                        />
                      </span>
                    </span>
                    <span class="indicator-progress">
                      Please wait...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </button>

                  <button type="submit" class="btn btn-lg btn-primary" v-else>
                    Continue
                    <span class="svg-icon svg-icon-3 ms-1 me-0">
                      <inline-svg
                        src="media/icons/duotone/Navigation/Right-2.svg"
                      />
                    </span>
                  </button>
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Actions-->
            </form>
            <!--end::Form-->
          </div>
          <!--end::Stepper-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - Create project-->
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";

import {getcountries, getcities}  from "@/api/common";
import { confirm_register, save_register}  from "@/api/register";
import { getCurrentUser } from "@/utils/index"


import ConfirmRegisterBiboEndorser from "@/views/auth/ConfirmRegisterBiboEndorser.vue";

interface Step1 { 
  insured_firstName: string;
  insured_middleName: string;
  insured_lastName: string;
  insured_birthday: string;
  username: string;
  password: string;
  cpassword: string;
  sponsorid: string;
  uplineid: string;
  position: string;
}

interface Step2 { 
  
 

}

interface Step3 {
  userid: string;
  securitypin: string;
  verifyingdata: boolean; 
  country_text: string;
  province_text: string;
  responsedata: object;
}

interface Step4 {
}

interface KTCreateApp extends Step1, Step2, Step3, Step4 {}

export default defineComponent({
  name: "create-account-modal",
  data() {
    return {   
        address_country: "",
        confirm_data: {},
         user : {}

    }
  },
  components: {
    Field,
    ErrorMessage,
    ConfirmRegisterBiboEndorser
  },
  props: { 
        slotdata: Object
  },
  setup(props, context) {
    const _stepperObj = ref<StepperComponent | null>(null);
    const createAccountRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);

    const countries = ref([]) as any; 
    const cities = ref([]) as any; 


    const isDisabledUPID = props.slotdata !== undefined && props.slotdata.upid !== undefined;
    const isBibo = String(localStorage.getItem("pt")) == "bibo";
    
    const httpGetCountries =  async () => { 
      countries.value = [];
        const response = await getcountries(); 
        if(response.data !== undefined && response.data.countries !== undefined) {
          countries.value = response.data.countries; 
        }
       
    }; 


    const getCities = async(country_id) => {  
        cities.value = [];
        const response = await getcities(country_id); 
        if(response.data !== undefined && response.data.cities !== undefined) {
            cities.value = response.data.cities; 
        }
    };


    const formData = ref<KTCreateApp>({   
      
      verifyingdata: false,
      country_text: "",
      province_text: "",
      responsedata: {},
      insured_firstName: "",
      insured_middleName: "",
      insured_lastName: "",
      insured_birthday: "",
      username: "",
      password: "",
      cpassword: "",
      sponsorid:  (props.slotdata !== undefined && props.slotdata.spid !== undefined) ? props.slotdata.spid : "",
      uplineid: (props.slotdata !== undefined && props.slotdata.upid !== undefined) ? props.slotdata.upid : "",
      position: (props.slotdata !== undefined && props.slotdata.position !== undefined) ? props.slotdata.position : "",
      
      userid: "",
      securitypin: ""
    });
 
    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        createAccountRef.value as HTMLElement
      );   
      console.log("mounted registermodalbibo");

      if(props.slotdata !== undefined && props.slotdata.upid !== undefined) {
          formData.value.uplineid = props.slotdata.upid;
          formData.value.sponsorid = props.slotdata.spid;
          formData.value.position = props.slotdata.position;
      }
      httpGetCountries();
    });

    const createAppSchema = [
      Yup.object({}),  
      
      Yup.object({ 
        username: Yup.string()
          .required()
          .label("Your Account Username"),
        password: Yup.string()
          .required()
          .label("Your Account Password"),
        cpassword: Yup.string()
          .required()
          .label("Your Account Password Confirmation"), 
        sponsorid: Yup.string()
          .required()
          .max(20)
          .label("Sponsor User ID"),
        uplineid: Yup.string()
          .required()
          .max(20)
          .label("Upline User ID"),
        position: Yup.string()
          .required()
          .label("Position")
      }), 

     

      Yup.object({ 
        userid: Yup.string()
          .required()
          .max(20)
          .label("Activation User ID"),
        securitypin: Yup.string()
          .required()
          .max(20)
          .label("Activation PIN") 


      }) 
    ];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value];
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const { resetForm, handleSubmit } = useForm<Step1 | Step2 | Step3 | Step4>({
      validationSchema: currentSchema
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = handleSubmit(values => {
      for (const item in values) {
        // eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(item)) {
          if (values[item]) {
            formData.value[item] = values[item];
          }
        }
      }

      currentStepIndex.value++;
 

      if (!_stepperObj.value) {
        return;
      }

      
      if(currentStepIndex.value === 2){ 
        validateForm(formData.value);
      }

      _stepperObj.value.goNext();
    });
    
    
const validateForm = async (data: any) => { 
      formData.value.verifyingdata = true;
      const response: any =   await confirm_register(data);
      
      formData.value.verifyingdata = false;
    

      if(response.data !== undefined && response.data.result === "FAILED") {  
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });  
           if (!_stepperObj.value) {
              return;
           }
           currentStepIndex.value = 0;
          _stepperObj.value.goFirst();
          return;
      }  
      
      if(response.data !== undefined && response.data.result === "SUCCESS") {
          formData.value.responsedata = response.data;
      }

    };

    const formSubmit = async () => {
       
      const response: any =   await save_register(formData.value);
       
      

      if(response.data !== undefined && response.data.result === "FAILED") {  
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });  
           if (!_stepperObj.value) {
              return;
           }
           currentStepIndex.value = 0;
          _stepperObj.value.goFirst();
          return;
      }  
      
      if(response.data !== undefined && response.data.result === "SUCCESS") {
              Swal.fire({
                text: response.data.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-primary"
                }
              }).then(() => {
                window.location.reload();
              });
      }

      
 
    };

    resetForm({
      values: {
        ...formData.value
      }
    });

    return {
      createAccountRef,
      totalSteps,
      previousStep,
      handleStep,
      formSubmit,
      currentStepIndex,
      formData,  
      countries,
      getCities,
      cities,
      isDisabledUPID,
      isBibo
    };
  },
  methods: {
     
    getCurrentUserFirstName(){
       this.user = getCurrentUser();
     }
    
  },
  mounted() { 
    this.getCurrentUserFirstName(); 
    //this.getcountries(); 
   // this.httpGetCountries();
  },
});
</script>
